import Login from './pages/Login.vue';
import NotFound from './pages/404.vue';
import Home from './pages/Home.vue';
/*商品信息*/
import productControl from './pages/productInformation/productControl.vue'; //商品管理
import packageControl from './pages/productInformation/packageControl.vue'; //套餐管理
import otherProduct from './pages/productInformation/otherProduct.vue'; //其他出入库
import addProduct from './pages/productInformation/addProduct.vue'; //添加单品
import addPackage from './pages/productInformation/addPackage.vue'; //添加套餐
import ProductAdd from './pages/productInformation/ProductAdd.vue'; //添加商品
/*下单*/
import SaleOrder from './pages/Order/SaleOrder.vue'; //销售下单列表
import addOrder from './pages/Order/addOrder.vue'; //新增销售下单
import AuditViewOrder from './pages/Order/AuditViewOrder.vue'; //查看订单
//2017/11/1新增会销下单模块
import MeetOrder from './pages/Order/MeetOrder/index.vue'; //会销下单
import zqwOrder from './pages/Order/zqwOrder/index.vue'; //新增智趣坞在线教育下单 2017/12/14
import MeetOrederDetails from './pages/Order/MeetOrederDetails/index.vue'; //新增会销资源包明细 2017/12/26
import HiOrder from './pages/Order/HiOrder/index.vue' //HiB下单
import LBHomeOrder from './pages/Order/LBHomeOrder/index.vue' //联帮在家下单

import roleControl from './pages/acountManage/roleControl.vue';
import SaleCheck from './pages/Order/SaleCheck.vue'; //审核销售下单列表
import SendGoods from './pages/SendGoods/SendGoods.vue'; //发货通知审核列表
import AuditViewSendGoods from './pages/SendGoods/AuditViewSendGoods.vue'; //发货通知审核查看

import financialList from './pages/Order/financialList/index.vue'; //财务审核-列表
import NeikongAuditList from './pages/Order/NeikongAuditList/index.vue'; //财务审核-列表
import financialHomeList from './pages/Family/financialHomeList/index.vue'; //财务审核-家庭端

import ViewSendGoodsForBus from './pages/SendGoods/ViewSendGoodsForBus.vue'; //查看发货通知单(商务)
import ViewSendGoodsForStock from './pages/SendGoods/ViewSendGoodsForStock.vue'; //查看发货通知单(仓库)
import SendGoodsForCKPage from './pages/SendGoods/SendGoodsForCKPage.vue'; //出库-打印发货通知单
import Exchange from './pages/Order/Exchange/index.vue'; //换货确认-列表
import ExchangeViewOrder from './pages/Order/Exchange/components/ExchangeViewOrder/index.vue'; //换货确认查看
// 2017/11/9 新增凭证审核 金蝶对接版需求
import voucherAudit from './pages/Order/voucherAudit/index.vue'; //审核---凭证审核

import SendGoodsForBus from './pages/SendGoods/SendGoodsForBus.vue'; //发货通知(商务)
import SendGoodsForStock from './pages/SendGoods/SendGoodsForStock.vue'; //发货通知(仓库)
import SendGoodsForHX from './pages/SendGoods/SendGoodsForHX.vue'; //发货通知(海信)
import SendGoodsForHXView from './pages/SendGoods/SendGoodsForHXView.vue'; //发货通知(海信)-查看
import AddStockOutHX from './pages/StockOut/AddStockOutHX.vue'; //生成出库单(海信)
import SendGoodsForHXPage from './pages/SendGoods/SendGoodsForHXPage.vue'; // 打印-发货通知单-海信


import StockOutByPage from './pages/StockOut/StockOut.vue'; //出库单(仓库)
import StockOutHX from './pages/StockOut/StockOutHX.vue'; //出库单(海信)
// 新增hi幼教资源包提货情况 2018/01/10
import hiPackage from './pages/Agent/hiPackage/index.vue';

import AgentOrder from './pages/Agent/AgentOrder.vue'; //订单管理
import AddStockOut from './pages/StockOut/AddStockOut.vue'; //出库单（仓库）
import VStockOut from './pages/StockOut/VStockOut.vue'; //查看出库单（仓库）
import StockOutHXView from './pages/StockOut/StockOutHXView.vue'; //查看出库单（海信）

import ViewOrder from './pages/Order/ViewOrder.vue'; //查看销售订单/审核查看
import CreateSkipOrder from './pages/Order/CreateSkipOrder'; //生成发货单
import viewAgentOrder from './pages/Agent/viewAgentOrder'; //代理商--查看订单信息
import SendGoodsPage from './pages/SendGoods/SendGoodsPage.vue'; // 打印-发货通知单
import organization from './pages/personManage/organization/organization.vue'; //人事管理---组织管理
import EmployeeManage from './pages/personManage/EmployeeManage/EmployeeMange.vue'; //人事管理--员工管理

import IntentionalAgent from './pages/CRMAgentManage/IntentionalAgent/index.vue'; //代理商管理--意向用户列表
import AgentAudit from './pages/CRMAgentManage/AgentAudit/index.vue'; //代理商管理--账户审核
import AgentAreaList from './pages/CRMAgentManage/AgentAreaList/index.vue'; //代理商管理--区域列表
import AgentAreaCheckList from './pages/CRMAgentManage/AgentAreaCheckList/index.vue'; //代理商管理--区域审核列表
import ViewIntendedUsers from './pages/ViewCRMAgentManage/IntendedUsers.vue'; //代理商管理--意向用户列表(查看)
//import ViewagentExamine from './pages/ViewCRMAgentExamine/index.vue';//代理商管理--意向用户列表
import AddEmployee from './pages/Agent/AddEmployee/index.vue'; //代理商管理--新增地推业务员

import CRMAgentAccountManage from './pages/CRMAgentAccountManage/index.vue'; //代理商账号管理
import AgentLend from './pages/Agent/AgentLend/index.vue'; //代理商管理-代理商借款详情
import agentPoor from './pages/CRMagentPoor/index.vue'; //代理商管理--公共池
import formatAgent from './pages/CRMAgentManage/CRMFormatAgent/index.vue'; //代理商管理--正式代理商列表
import formatAgentList from './pages/ViewCRMFormatAgent/index.vue'; //代理商管理--正式代理商列表("列表")

// school
import AddSchool from './pages/school/AddSchool/index.vue'; //添加幼儿园
import checkSchool from './pages/school/checkSchool/checkSchool.vue'; //幼儿园 管理--审核管理
import purposeSchool from './pages/school/purposeSchool/purposeSchool.vue'; //幼儿园 管理--意向园列表
import scatteredSchool from './pages/school/scatteredSchool/scatteredSchool.vue'; //幼儿园 管理--零散园列表
import reportSchool from './pages/school/reportSchool/reportSchool.vue'; //幼儿园 管理--审核管理
import officialSchool from './pages/school/officialSchool/officialSchool.vue'; //幼儿园管理--正式园列表
import viewofficialSchool from './pages/school/ViewofficialSchool/officialSchool.vue'; //幼儿园管理--正式幼儿园列表(查看)
import SchoolEquipment from './pages/school/SchoolEquipment/SchoolEquipment.vue'; //园所设备列表
import waitPayOrderList from './pages/Order/waitPayOrderList/index.vue'; //待支付订单
import testClassAudit from './pages/Order/testClassAudit/index.vue'; //试课审核
import hardWareList from './pages/HardWare/hardWareList.vue'; //设备管理-设备列表
import refund from './pages/Order/refund/index.vue'; //审核---退款审核
import orderAudit from './pages/Order/orderAudit/index.vue'; //审核---订单审核（智趣坞独家）2017/12/14
import StockOutStorage from './pages/storage/StockOutStorage/index.vue'; //出库单(仓库)
import SendGoodsStorage from './pages/storage/SendGoodsStorage/index.vue'; // 发货通知（仓库)

import CancellationOrder from './pages/Order/CancellationOrder/index.vue';
import startClassApplicationList from './pages/Order/startClassApplicationList/index.vue';

import makeOutInvoice from './pages/Order/makeOutInvoice/index.vue'; //开票申请
import reviewOfCooperationAgreement from './pages/Order/reviewOfCooperationAgreement/index.vue'; //合作协议审核

import exportOrderAndStockoutOrder from './pages/exportFunction/exportOrderAndStockoutOrder/index.vue'; //导出订单与出库单

// 新增备忘录菜单
import PackageRule from './pages/Memorandum/PackageRule/index.vue'; //套餐规则
import SpecialMatter from './pages/Memorandum/SpecialMatter/index.vue'; //特殊事项

//家庭端
import OrderList from './pages/Family/OrderList/index.vue'; //家庭端订单列表
import NoPayOrderList from './pages/Family/NoPayOrderList/index.vue'; //家庭端未支付订单列表
import SendNotice from './pages/Family/SendNotice/index.vue'; //发货通知
import CreateStockOut from './pages/Family/SendNotice/CreateStockOut/index.vue' //生成出库单
// import SendPrint from './pages/Family/SendNotice/SendPrint/index.vue' //发货通知打印单
import StockOut from './pages/Family/StockOut/index.vue'; //出库单
import StudentsList from './pages/Family/StudentsList/index.vue'; //出库单



// 新增园务下单大模块（包含会销开课，会销开课订单，续订套餐）
import MeetOpenClass from './pages/SchoolOrder/MeetOpenClass/index.vue'; // 会销开课
import MeetOpenClassOrder from './pages/SchoolOrder/MeetOpenClassOrder/index.vue'; // 会销开课订单
import BookPackage from './pages/SchoolOrder/BookPackage/index.vue'; // 续订套餐
import ContinuePackage from './pages/SchoolOrder/ContinuePackage/index.vue'; // 续订资源包
import SendLesson from './pages/SchoolOrder/SendLesson/index.vue'; // 送课申请
import SendLessonCheck from './pages/SchoolOrder/SendLessonCheck/index.vue'; // 送课申请审核
import SummerSchoolOrder from './pages/SchoolOrder/SummerSchoolOrder/index.vue' //暑期班订单
import D55Order from './pages/SchoolOrder/D55Order/index.vue' //暑期班订单

// 新增订单列表（查看）
import OrderCommonPage from './pages/Order/orderViewList/OrderCommonPage/index.vue'
import OrderAuditList from './pages/Order/orderViewList/OrderAuditList/index.vue' //财务审核（查看）
import OrderQ2Page from './pages/Order/orderViewList/OrderQ2Page/index.vue'

// 18Q2网络检测
import checkList from './pages/Network/checkList/index.vue'
import networkCheck from './pages/Network/networkCheck/index.vue'

let routes = [{
        path: '/login',
        component: Login,
        name: '',
        hidden: true,
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true,
    },
    {
        path: '/',
        component: Home,
        name: '商品信息',
        iconCls: 'el-icon-message', //图标样式class
        MenuId: 1,
        hidden: true,
        children: [{
                path: '/productInformation/productControl',
                component: productControl,
                name: '单品管理',
                hidden: true,
                MenuId: 9,
                children: [{
                    path: "/productInformation/productControl/addProduct",
                    component: addProduct,
                    name: "添加单品"
                }]
            },
            {
                path: '/productInformation/packageControl',
                component: packageControl,
                MenuId: 10,
                hidden: true,
                name: '套餐管理',
                children: [{
                    path: "/productInformation/productControl/addPackage",
                    component: addPackage,
                    name: "添加套餐"
                }]
            }, {
                path: '/productInformation/otherProduct',
                component: otherProduct,
                name: '其它出入库商品管理',
                hidden: true,
                MenuId: 49,
                children: [{
                    path: "/productInformation/productControl/ProductAdd",
                    component: ProductAdd,
                    name: "新增商品"
                }]
            }
        ]
    }, {
        path: '/',
        component: Home,
        name: '网络检测',
        iconCls: 'fa fa-desktop', //图标样式class
        MenuId: 116,
        hidden: true,
        children: [{
            path: '/Network/networkListAll',
            component: networkCheck,
            name: '全部',
            hidden: true,
            MenuId: 117,
        }, {
            path: '/Network/networkDevice',
            component: networkCheck,
            name: '设备安装跟进',
            hidden: true,
            MenuId: 118,
        }, {
            path: '/Network/networkCheck',
            component: networkCheck,
            name: '网络检测',
            hidden: true,
            MenuId: 119,
        }, {
            path: '/Network/checkList',
            component: checkList,
            name: '网络检测配置表',
            hidden: true,
            MenuId: 120,
        }, ]
    },
    {
        path: '/',
        component: Home,
        name: '下单',
        iconCls: 'fa fa-id-card-o',
        MenuId: 2,
        hidden: true,
        children: [{
            path: '/Order/SaleOrder',
            component: SaleOrder,
            name: '销售下单',
            MenuId: 11,
            hidden: true,
            children: [{
                    path: "/Order/SaleOrder/addOrder",
                    component: addOrder,
                    name: "销售下单"
                },
                {
                    path: "/Order/SaleOrder/ViewOrder",
                    component: ViewOrder,
                    name: "查看"
                },
                {
                    path: "/Order/SaleOrder/CreateSkipOrder",
                    component: CreateSkipOrder,
                    name: " 发货通知单"
                }
            ]
        }]
    }, {
        path: '/',
        component: Home,
        name: '市场',
        iconCls: 'fa fa-tasks',
        MenuId: 67,
        hidden: true,
        children: [
        //   {
        //     // 仅用于临时下2017Q4会销订单
        //     path: '/Order/MeetOrder2',
        //     component: MeetOrder,
        //     name: '会销',
        //     MenuId: 108,
        //     hidden: true,
        // }, {
        //     path: '/Order/MeetOrder',
        //     component: MeetOrder,
        //     name: '会销下单',
        //     MenuId: 68,
        //     hidden: true,
        // },
         {
            path: '/Order/MeetOrederDetails',
            component: MeetOrederDetails,
            name: '会销资源包明细',
            MenuId: 73,
            hidden: true,
        }, {
            path: '/Order/zqwOrder',
            component: zqwOrder,
            name: '智趣坞独家下单',
            MenuId: 70,
            hidden: true,
        }
        // , {
        //     path: '/Order/HiOrder',
        //     component: HiOrder,
        //     name: 'HiB设备开课',
        //     MenuId: 121,
        //     hidden: true,
        // }, {
        //     path: '/Order/LBHomeOrder',
        //     component: LBHomeOrder,
        //     name: '联帮在家下单',
        //     MenuId: 125,
        //     hidden: true,
        // }
      ]
    }, {
        path: '/',
        component: Home,
        name: '订单',
        iconCls: 'fa fa-pencil-square-o',
        MenuId: 113,
        hidden: true,
        children: [{
            path: "/Order/orderViewList/financialListReadyOnly",
            component: OrderAuditList,
            name: "财务审核(查看)",
            MenuId: 55,
            hidden: true,
        }, {
            path: "/Order/orderViewList/SchoolOrderView",
            component: OrderCommonPage,
            name: '订单查看(Hi-E)',
            MenuId: 107,
            hidden: true,
        }, {
            path: "/Order/orderViewList/Q2/:114",
            component: OrderQ2Page,
            name: '订单列表(Q2直营)',
            MenuId: 114,
            hidden: true,
        }, {
            path: "/Order/orderViewList/Book/:115",
            component: OrderCommonPage,
            name: '订单列表(智趣坞独家)',
            MenuId: 115,
            hidden: true,
        }]
    }, {
        path: '/',
        component: Home,
        name: '园务下单',
        iconCls: 'fa fa-pencil-square-o',
        MenuId: 80,
        hidden: true,
        children: [
            //     {
            //     path: "/SchoolOrder/SchoolOrderView",
            //     component: financialList,
            //     name: '订单查看(Hi-E)',
            //     MenuId: 107,
            //     hidden: true,
            // }, 
            {
                path: '/Order/SchoolOrder/MeetOpenClass',
                component: MeetOpenClass,
                name: '会销开课',
                MenuId: 81,
                hidden: true,
            }, {
                path: '/Order/SchoolOrder/MeetOpenClassOrder',
                component: MeetOpenClassOrder,
                name: '会销相关订单',
                MenuId: 82,
                hidden: true,
            }, {
                path: '/Order/SchoolOrder/BookPackage',
                component: BookPackage,
                name: '续订套餐',
                MenuId: 83,
                hidden: true,
            }, {
                path: '/Order/SchoolOrder/ContinuePackage',
                component: ContinuePackage,
                name: '续订资源包',
                MenuId: 93,
                hidden: true,
            }, {
                path: '/Order/SchoolOrder/SendLesson',
                component: SendLesson,
                name: '送课申请',
                MenuId: 127,
                hidden: true,
            }
            // , {
            //     path: '/Order/SchoolOrder/SummerSchoolOrder',
            //     component: SummerSchoolOrder,
            //     name: '暑期班订单',
            //     MenuId: 131,
            //     hidden: true,
            // },
            // {
            //     path: '/Order/SchoolOrder/D55Order',
            //     component: D55Order,
            //     name: 'D55/D65下单',
            //     MenuId: 132,
            //     hidden: true,
            // },

        ]
    }, {
        path: '/',
        component: Home,
        name: '家庭端订单',
        iconCls: 'fa fa-navicon', //图标样式class
        MenuId: 85,
        hidden: true,
        children: [{
            path: '/Family/NoPayOrderList',
            component: NoPayOrderList,
            name: '未支付订单',
            hidden: true,
            MenuId: 106,
        }, {
            path: '/Family/OrderList',
            component: OrderList,
            name: '订单列表（家庭端）',
            hidden: true,
            MenuId: 86,
        }, {
            path: '/Family/SendNoticeStoreHouse',
            component: SendNotice,
            name: '发货通知(仓库)',
            hidden: true,
            MenuId: 87,
            children: [{
                path: '/Family/SendNoticeStoreHouse/SendNoticePrint',
                component: SendGoodsForHXPage,
                name: "打印发货单（仓库）"
            }, {
                path: '/Family/SendNoticeStoreHouse/CreatStockOutPage',
                component: CreateStockOut,
                name: "生成出库单（仓库）"
            }]
        }, {
            path: '/Family/SendNoticePackage',
            component: SendNotice,
            name: '发货通知(资源包)',
            hidden: true,
            MenuId: 88,
            children: [{
                path: '/Family/SendNoticePackage/SendNoticePrint',
                component: SendGoodsForHXPage,
                name: "打印发货单（资源包）"
            }, {
                path: '/Family/SendNoticePackage/CreatStockOutPage',
                component: CreateStockOut,
                name: "生成出库单（资源包）"
            }]
        }, {
            path: '/Family/SendNoticeHX',
            component: SendNotice,
            name: '发货通知(海信)',
            hidden: true,
            MenuId: 89,
            children: [{
                path: '/Family/SendNoticeHX/SendNoticePrint',
                component: SendGoodsForHXPage,
                name: "打印发货单（海信）"
            }, {
                path: '/Family/SendNoticeHX/CreatStockOutPage',
                component: CreateStockOut,
                name: "生成出库单（海信）"
            }]

        }, {
            path: '/Family/StockOutStoreHouse',
            component: StockOut,
            name: '出库单(仓库)',
            hidden: true,
            MenuId: 91,
        }, {
            path: '/Family/StockOutHX',
            component: StockOut,
            name: '出库单(海信)',
            hidden: true,
            MenuId: 90,
        }, {
            path: '/Family/StockOutPackage',
            component: StockOut,
            name: '出库单(资源包)',
            hidden: true,
            MenuId: 92,
        }, {
            path: '/Family/StudentsList',
            component: StudentsList,
            name: '学员名单',
            hidden: true,
            MenuId: 126,
        }, ]
    }, {
        path: '/',
        component: Home,
        name: '审核',
        iconCls: 'fa fa-address-card',
        MenuId: 3,
        hidden: true,
        children: [{
                path: '/Order/SaleCheck',
                component: SaleCheck,
                name: '销售下单审核',
                MenuId: 12,
                hidden: true,
                children: [{
                    path: '/Order/AuditViewOrder',
                    component: AuditViewOrder,
                    name: '查看订单',
                }]
            },
            {
                path: '/SendGoods/SendGoods',
                component: SendGoods,
                name: '发货通知审核',
                MenuId: 13,
                hidden: true,
                children: [{
                    path: '/SendGoods/AuditViewSendGoods',
                    component: AuditViewSendGoods,
                    name: '发货通知单审核',
                }]
            },
            {
                path: '/Order/waitPayOrderList',
                component: waitPayOrderList,
                name: '未支付订单',
                MenuId: 39,
                hidden: true
            },
            {
                path: '/Order/financialList',
                component: financialList,
                name: '财务审核',
                MenuId: 34,
                hidden: true,
                children: [{
                    path: "/Order/financialList/ViewOrder",
                    component: ViewOrder,
                    name: "财务审核查看"
                }]
            },
            // 新增财务审核（直营）
            {
                path: "/Order/financialListPassOrder",
                component: financialList,
                name: "财务审核(直营)",
                MenuId: 84,
                hidden: true,
            },
            {
                path: '/Order/financialHomeList',
                component: financialHomeList,
                name: '财务审核（家庭端）',
                hidden: true,
                MenuId: 124,
            },
            // 新增财务审核（会销） 2018/01/08（冰冰）
            {
                path: "/Order/financialListMeetOrder",
                component: NeikongAuditList,
                name: "内控审核",
                MenuId: 109,
                hidden: true,
            },
            // {
            //     path: "/Order/financialListReadyOnly",
            //     component: financialList,
            //     name: "财务审核(查看)",
            //     MenuId: 55,
            //     hidden: true,
            // },
            {
                path: "/Order/refund",
                component: refund,
                name: "退款审核",
                MenuId: 41,
                hidden: true,
            },
            {
                path: "/Order/voucherAudit",
                component: voucherAudit,
                name: "凭证审核",
                MenuId: 69,
                hidden: true,
            },
            {
                path: "/Order/orderAudit",
                component: orderAudit,
                name: "订单审核(智趣坞独家)",
                MenuId: 71,
                hidden: true,
            },
            {
                path: "/Order/testClassAudit",
                component: testClassAudit,
                name: "试课审核",
                MenuId: 42,
                hidden: true,
            },
            {
                path: "/Order/CancellationOrder",
                component: CancellationOrder,
                name: "撤销的订单",
                MenuId: 51,
                hidden: true,
            },
            // {
            //     path: "/Order/startClassApplicationList",
            //     component: startClassApplicationList,
            //     name: "开通申请",
            //     MenuId: 52,
            //     hidden: true,
            // },
            {
                path: "/Order/makeOutInvoice",
                component: makeOutInvoice,
                name: "开票申请",
                MenuId: 45464, //54
                hidden: false,
            },
            // {
            //     path: "/Order/reviewOfCooperationAgreement",
            //     component: reviewOfCooperationAgreement,
            //     name: "合作协议审核",
            //     MenuId: 57, //57
            //     hidden: false,
            // },
            {
                path: '/Order/SchoolOrder/SendLessonCheck',
                component: SendLessonCheck,
                name: '送课审核',
                MenuId: 128,
                hidden: true,
            },
        ]
    },
    {
        path: '/',
        component: Home,
        name: '发货通知单',
        iconCls: 'fa fa-bar-chart',
        MenuId: 4,
        hidden: true,
        children: [{
                path: '/SendGoods/SendGoodsForBus',
                component: SendGoodsForBus,
                name: '发货通知(商务)',
                MenuId: 14,
                hidden: true,
                children: [{
                    path: '/SendGoods/ViewSendGoodsForBus',
                    component: ViewSendGoodsForBus,
                    name: '查看发货通知单(商务)',
                }]
            },
            {
                path: "/SendGoods/SendGoodsStorage",
                component: SendGoodsStorage,
                name: "发货通知(仓库)",
                MenuId: 43,
                hidden: true,
                children: [{
                    path: '/SendGoods/ViewSendGoodsForStock',
                    component: ViewSendGoodsForStock,
                    name: '查看发货通知单(仓库)'
                }, {
                    path: '/StockOut/AddStockOut',
                    component: AddStockOut,
                    name: '生成出库单(仓库)',
                }]
            },
            {
                path: '/SendGoods/SendGoodsForStock',
                component: SendGoodsForStock,
                name: '发货通知（资源包）',
                MenuId: 15,
                hidden: true,
                children: [{
                    path: '/SendGoods/ViewSendGoodsForResourcePackage',
                    component: ViewSendGoodsForStock,
                    name: '查看发货通知单(资源包)',
                    children: [{
                        path: '/SendGoods/ViewSendGoodsForStock/SendGoodsPage',
                        component: SendGoodsPage,
                        name: "打印发货单"
                    }, {
                        path: '/SendGoods/ViewSendGoodsForStock/SendGoodsForCKPage',
                        component: SendGoodsForCKPage,
                        name: "打印发货单"
                    }]
                }, {
                    path: '/StockOut/AddStockResources',
                    component: AddStockOut,
                    name: '生成出库单(资源包)'
                }]
            },
            {
                path: '/SendGoods/SendGoodsForHX',
                component: SendGoodsForHX,
                name: '发货通知(海信)',
                MenuId: 35,
                hidden: true,
                children: [{
                    path: '/SendGoods/SendGoodsForHXView',
                    component: SendGoodsForHXView,
                    name: '查看发货通知单(海信)',
                    children: [{
                        path: '/SendGoods/SendGoodsForHXView/SendGoodsForHXPage',
                        component: SendGoodsForHXPage,
                        name: "打印发货单-海信"
                    }]
                }, {
                    path: '/StockOut/AddStockOutHX',
                    component: AddStockOutHX,
                    name: '生成出库单(海信)',
                }]
            },
            {
                path: "/Order/Exchange",
                component: Exchange,
                name: "退还确认",
                MenuId: 61,
                hidden: true,
                children: [{
                    path: '/Order/Exchange/ExchangeViewOrder',
                    component: ExchangeViewOrder,
                    name: '换货查看',
                }]
            },
            {
                path: "/Order/ExchangeConfirm",
                component: Exchange,
                name: "换货确认",
                MenuId: 62,
                hidden: true,
                children: [{
                    path: '/Order/Exchange/ExchangeViewOrder',
                    component: ExchangeViewOrder,
                    name: '换货确认查看',
                }]
            }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '发货管理',
        iconCls: 'el-icon-document',
        MenuId: 5,
        hidden: true,
        children: [{
                path: '/StockOut/StockOutByPage',
                component: StockOutByPage,
                name: '出库单（资源包）',
                MenuId: 16,
                children: [{
                    path: '/StockOut/VStockOut',
                    component: VStockOut,
                    name: '查看出库单',
                }]
            },
            {
                path: "/StockOut/StockOutStorage",
                component: StockOutStorage,
                name: "出库单(仓库)",
                MenuId: 44,
                hidden: true,
            },
            {
                path: "/StockOut/onlyViewStockOutStorage",
                component: StockOutStorage,
                name: "出库单(仓库)-查看",
                MenuId: 53,
                hidden: true,
            },
            {
                path: '/StockOut/StockOutHX',
                component: StockOutHX,
                name: '出库单(海信)',
                MenuId: 36,
                children: [{
                    path: '/StockOut/StockOutHXView',
                    component: StockOutHXView,
                    name: '查看出库单',
                }]
            }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '代理商',
        iconCls: 'el-icon-check',
        MenuId: 6,
        hidden: true,
        children: [{
            path: '/AgentOrder/AgentOrder',
            component: AgentOrder,
            name: '订单管理',
            MenuId: 17,
            hidden: true,
            children: [{
                path: '/AgentOrder/AgentOrder/viewAgentOrder',
                component: viewAgentOrder,
                name: '订单信息',
            }]
        }]
    }, {
        path: '/',
        component: Home,
        name: '导出',
        iconCls: 'el-icon-check',
        MenuId: 58,
        hidden: true,
        children: [{
            path: '/exportFunction/exportOrderAndStockoutOrder',
            component: exportOrderAndStockoutOrder,
            name: '导出订单与出库单',
            MenuId: 59,
            hidden: true
        }]
    },
    {
        path: '/',
        component: Home,
        name: '管理员设置',
        iconCls: 'el-icon-setting',
        MenuId: 7,
        hidden: true,
        children: [{
            path: '/acountManage/roleControl',
            component: roleControl,
            name: '角色管理',
            MenuId: 8,
            hidden: true,
        }]
    },
    {
        path: '/',
        component: Home,
        name: '人事管理',
        iconCls: 'el-icon-document',
        MenuId: 18,
        hidden: true,
        children: [{
                path: '/acountManage/organization',
                component: organization,
                name: '组织架构',
                MenuId: 21
            },
            {
                path: '/acountManage/EmployeeManage',
                component: EmployeeManage,
                name: '员工管理',
                MenuId: 22
            }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '代理商管理',
        iconCls: 'el-icon-menu',
        MenuId: 19,
        hidden: true,
        children: [{
                path: '/acountManage/CRMAgentAccountManage',
                component: CRMAgentAccountManage,
                name: '代理商账户管理',
                MenuId: 40,
                hidden: true
            }, {
                path: '/acountManage/AgentLend',
                component: AgentLend,
                name: '代理商借款详情',
                MenuId: 111,
                hidden: true
            },
            {
                path: '/acountManage/hiPackage',
                component: hiPackage,
                name: 'hi幼教资源包提货情况',
                MenuId: 79
            },
            // {
            //     path: '/CRMAgentManage/IntentionalAgent',
            //     component: IntentionalAgent,
            //     name: '意向客户列表',
            //     MenuId: 23,
            //     hidden: true
            // },
            // {
            //     path: '/acountManage/ViewIntendedUsers',
            //     component: ViewIntendedUsers,
            //     name: '意向客户列表(查看)',
            //     MenuId: 47,
            //     hidden: true
            // },
            // {
            //     path: '/acountManage/majorUsers',
            //     component: IntentionalAgent,
            //     name: '重点客户列表',
            //     MenuId: 24,
            //     hidden: true
            // },
            // {
            //     path: '/acountManage/ViewmajorUsers',
            //     component: ViewIntendedUsers,
            //     name: '重点客户列表(查看)',
            //     MenuId: 48,
            //     hidden: true
            // },
            // {
            //     path: '/CRMAgentManage/AgentAudit',
            //     component: AgentAudit,
            //     name: '账户审核',
            //     MenuId: 25,
            //     hidden: true
            // },
            // {
            //     path: '/CRMAgentManage/AgentAreaList',
            //     component: AgentAreaList,
            //     name: '区域列表',
            //     MenuId: 129,
            //     hidden: true
            // },
            // {
            //     path: '/CRMAgentManage/AgentAreaCheckList',
            //     component: AgentAreaCheckList,
            //     name: '区域审核',
            //     MenuId: 130,
            //     hidden: true
            // },
            {
                path: '/acountManage/agentPoor',
                component: agentPoor,
                name: '公共池',
                MenuId: 26,
                hidden: true
            },
            {
                path: '/acountManage/formatAgent',
                component: formatAgent,
                name: '正式代理商列表',
                MenuId: 27,
                hidden: true
            },
            {
                path: '/crmAgent/formatAgent',
                component: formatAgentList,
                name: '正式代理商列表(查看)',
                MenuId: 45,
                hidden: true
            },
            {
                path: '/crmAgent/searchFormatAgent',
                component: formatAgentList,
                name: '正式代理商列表(搜索)',
                MenuId: 50,
                hidden: true
            },
            {
                path: '/Agent/AddEmployee',
                component: AddEmployee,
                name: '地推业务员',
                MenuId: 112,
                hidden: true
            }
        ]
    },
    {
        path: "/",
        component: Home,
        name: "园所管理",
        iconCls: 'el-icon-date',
        MenuId: 20,
        hidden: true,
        children: [
            //   {
            //         path: '/school/purposeSchool',
            //         component: purposeSchool,
            //         name: '意向园所列表',
            //         MenuId: 28,
            //         hidden: true
            //     },
            // {
            //     path: '/school/checkSchool',
            //     component: checkSchool,
            //     name: '审核管理',
            //     MenuId: 32,
            //     hidden: true
            // },
            // {
            //     path: '/school/AddSchool',
            //     component: AddSchool,
            //     name: '添加幼儿园',
            //     MenuId: 72,
            //     hidden: true
            // },
            // {
            //     path: '/school/scatteredSchool',
            //     component: scatteredSchool,
            //     name: '零散园所列表',
            //     MenuId: 29,
            //     hidden: true
            // },
            // {
            //     path: '/school/reportSchool',
            //     component: reportSchool,
            //     name: '报备园所列表',
            //     MenuId: 30,
            //     hidden: true
            // },
            // {
            //     // 新增正式幼儿园（培训），界面功能都和正式幼儿园列表一样（2018/01/10冰冰）
            //     path: '/school/SchoolTrain',
            //     component: officialSchool,
            //     name: '正式幼儿园(培训)',
            //     MenuId: 74,
            //     hidden: true
            // },
            // {
            //     path: '/school/officialSchool',
            //     component: officialSchool,
            //     name: '正式幼儿园列表',
            //     MenuId: 31,
            //     hidden: true
            // },
            {
                path: '/school/viewofficialSchool',
                component: viewofficialSchool,
                name: '正式幼儿园列表(查看)',
                MenuId: 46,
                hidden: true
            },
            {
                path: '/school/SchoolEquipment',
                component: SchoolEquipment,
                name: '幼儿园设备',
                MenuId: 33,
                hidden: true
            }
        ]
    },
    {
        path: "/",
        component: Home,
        name: "设备管理",
        iconCls: 'fa fa-inbox',
        MenuId: 37,
        hidden: true,
        children: [{
            path: '/HardWare/hardWareList',
            component: hardWareList,
            name: '设备列表',
            MenuId: 38,
            hidden: true
        }]
    }, {
        path: '/',
        component: Home,
        name: '备忘录',
        iconCls: 'fa fa-calendar', //图标样式class
        MenuId: 76,
        hidden: true,
        children: [{
                path: '/Memorandum/PackageRule',
                component: PackageRule,
                name: '套餐规则',
                hidden: true,
                MenuId: 77,
            },
            {
                path: '/Memorandum/SpecialMatter',
                component: SpecialMatter,
                MenuId: 78,
                hidden: true,
                name: '特殊事项',
            }
        ]
    },
    {
        path: '*',
        hidden: true,
        redirect: {
            path: '/404'
        }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js